const externalLinksData = require(`../data/externalLinks.json`)

/**
 * Get correct link of an external page based on brand and country.
 * If the link is not found, and empty string is returned.
 * @param  {String} brand The current brand
 * @param  {String} country The current country
 * @param  {String} page The page whose external link needs to be retrieved
 * @return {String} External page
 */
export function getExternalLink (brand, country, page) {
  if (page &&
    brand &&
    country &&
    externalLinksData.hasOwnProperty(brand) &&
    externalLinksData[brand].hasOwnProperty(country) &&
    externalLinksData[brand][country] &&
    externalLinksData[brand][country].hasOwnProperty(page) &&
    externalLinksData[brand][country][page]) {
    return externalLinksData[brand][country][page]
  }
  return ''
}
